// 大屏
export default [
  {
    path: '/security/overview',
    name: 'PageSecurityOverview',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityOverview'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '校园安全',
      info: '校园安全——首页'
    }
  },
  {
    path: '/security/overview/details',
    name: 'PageSecurityOverviewDetails',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityOverviewDetails'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '未识别到人',
      info: '校园安全——未识别到人'
    }
  },
  {
    path: '/security/member/unkonw',
    name: 'PageSecurityUnknownMembers',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityUnknownMembers'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '未识别到人员',
      info: '校园安全——未识别到人员'
    }
  },
  {
    path: '/security/member/details',
    name: 'PageSecurityMemberDetails',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityMemberDetails'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '校园安全',
      info: '校园安全-学生详情'
    }
  },

  {
    path: '/security/notice/details',
    name: 'PageSecurityNoticeDetails',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityNoticeDetails'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '校园安全',
      info: '校园安全——通知详情'
    }
  },
  {
    path: '/security/events',
    name: 'PageSecurityEvents',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityEvents'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '校园安全',
      info: '校园安全——报警事件'
    }
  },
  {
    path: '/security/event/details',
    name: 'PageSecurityEventDetails',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityEventDetails'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '详情',
      info: '校园安全——详情'
    }
  },
  {
    path: '/security/event/uploadResult',
    name: 'PageSecurityUploadResult',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityUploadResult'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '上传处理结果',
      info: '校园安全——上传处理结果'
    }
  },
  {
    path: '/security/setting',
    name: 'PageSecuritySetting',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecuritySetting'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '设置',
      info: '校园安全——设置'
    }
  },
  {
    path: '/security/notice',
    name: 'PageSecurityNotice',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityNotice'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '报警结果通知对象',
      info: '校园安全——报警结果通知对象'
    }
  },
  {
    path: '/security/notice/save',
    name: 'PageSecurityNoticeSave',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityNoticeSave'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '自定义通知组',
      info: '校园安全——自定义通知组'
    }
  },
  {
    path: '/security/notice/device',
    name: 'PageSecurityNoticeDevice',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityNoticeDevice'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '接收报警范围',
      info: '校园安全——接收报警范围'
    }
  },
  {
    path: '/security/device',
    name: 'PageSecurityDevice',
    component: () =>
      import(
        /* webpackChunkName: "security" */ '../pages/security/PageSecurityDevice'
      ),
    meta: {
      modular: 110,
      keepAlive: true,
      title: '全部设备',
      info: '校园安全——全部设备'
    }
  }
]
